import { useEffect, useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../../apiConfig";
import {
  getAdditionalActContractType,
  getAdditionalActWorkflow,
} from "./additionalActWorkflow";

export default function useAdditionalActPreview({
  issueId,
  contract,
  enabled,
  acceptedPrice,
  currentPrice,
  newPrice,
}) {
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState({});
  const contractType = getAdditionalActContractType(contract);
  const workflow = getAdditionalActWorkflow(contract);
  const previewPath = workflow.provider === "zoho" ? workflow.path : "";
  const key =
    enabled && issueId && previewPath
      ? JSON.stringify([
          issueId,
          contractType,
          previewPath,
          acceptedPrice,
          currentPrice,
          newPrice,
          revision,
        ])
      : "";

  useEffect(() => {
    if (!key) return undefined;

    const controller = new AbortController();
    let active = true;
    setState({ key, loading: true, data: null, error: "" });

    axios
      .get(
        buildApiUrl(
          `${previewPath}/${encodeURIComponent(issueId)}/preview`,
        ),
        {
          signal: controller.signal,
          ...(String(newPrice ?? "").trim() ? { params: { price: newPrice } } : {}),
        },
      )
      .then(({ data }) => {
        if (!active) return;
        if (data?.ok !== true) {
          throw new Error(data?.message || "Datele actului adițional nu au putut fi verificate.");
        }
        setState({ key, loading: false, data, error: "" });
      })
      .catch((error) => {
        if (!active) return;
        setState({
          key,
          loading: false,
          data: null,
          error:
            error.response?.data?.message ||
            error.message ||
            "Datele actului adițional nu au putut fi verificate.",
        });
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [key, issueId, newPrice, previewPath]);

  return {
    data: key && state.key === key ? state.data : null,
    loading: Boolean(key && (state.key !== key || state.loading)),
    error: key && state.key === key ? state.error : "",
    refresh: () => setRevision((value) => value + 1),
  };
}
